<template>
  <router-view />

  <!-- 全局加载遮罩（钱包连接时） -->
  <Transition name="fade">
    <div v-if="walletStore.isLoading"
         class="fixed inset-0 z-[999] flex items-center justify-center"
         style="background:rgba(0,0,0,0.6); backdrop-filter:blur(4px)">
      <div class="flex flex-col items-center gap-4">
        <svg class="animate-spin w-10 h-10"
             style="color:var(--color-primary)"
             fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10"
                  stroke="currentColor" stroke-width="4"/>
          <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8v8H4z"/>
        </svg>
        <p class="text-white font-medium">Connecting wallet...</p>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import { usePriceStore }  from '@/stores/price'
import { useWalletStore } from '@/stores/wallet'
import { useUserStore }   from '@/stores/user'
import { usePricePolling } from '@/composables/usePricePolling'

const priceStore  = usePriceStore()
const walletStore = useWalletStore()
const userStore   = useUserStore()
usePricePolling(30000)

// 保存定时器引用以便清除
let priceInterval = null

onMounted(async () => {
  console.log('App mounted') // 添加日志调试

  // 1. 加载价格信息（公开，无需登录）
  await priceStore.loadPriceInfo()

  // 2. 处理邀请码URL参数
  const urlParams = new URLSearchParams(window.location.search)
  const refCode   = urlParams.get('ref')
  if (refCode) {
    localStorage.setItem('referrer_code', refCode)
  }

  // 3. 尝试恢复登录会话（页面刷新后）
  const restored = await walletStore.restoreSession()
  if (restored) {
    // 静默加载用户数据
    try {
      await userStore.loadProfile()
      await userStore.loadBalance()
    } catch {
      // token失效，清除
      walletStore.disconnect()
    }
  }

})

// 组件卸载时清除定时器
onUnmounted(() => {
  if (priceInterval) {
    clearInterval(priceInterval)
    priceInterval = null
    console.log('Price interval cleared')
  }
})
</script>

<style>
/* 全局fade动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>